import React from 'react';
import { Quote } from 'lucide-react';
import Reveal from './Reveal';
import { storyImage } from '../mock';

const About = () => {
  return (
    <section id="about" className="py-24 md:py-32 bg-[#f5efe7]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal className="text-center mb-16">
          <p className="text-[#e6396b] tracking-[0.4em] text-[12px] font-semibold mb-5">
            ABOUT US
          </p>
          <h2 className="font-serif text-[44px] md:text-[64px] text-[#1a1a1a] font-medium">
            The Story
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-12 lg:gap-20 items-center">
          <Reveal className="order-2 md:order-1">
            <div className="relative overflow-hidden rounded-md shadow-xl group">
              <img
                src={storyImage}
                alt="The Fleetwood Mac Experience band photo"
                className="w-full h-auto object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 ring-1 ring-inset ring-black/5 pointer-events-none" />
            </div>
          </Reveal>

          <Reveal delay={150} className="order-1 md:order-2 space-y-6">
            <p className="text-[17px] md:text-[18px] text-[#4a4a4a] leading-[1.8]">
              The Fleetwood Mac Experience is a tribute band that passionately
              recreates the iconic Fleetwood Mac sound and look. Through live
              performances and dedication to detail, we bring the magic of
              Fleetwood Mac to life for fans old and new.
            </p>
            <p className="text-[17px] md:text-[18px] text-[#4a4a4a] leading-[1.8]">
              Think less concert, more celebration — a joyful, theatrical night
              out where the whole room sings and dances together. Our audiences
              don't just watch; they become part of the show.
            </p>

            <div className="bg-white border border-[#e7ddd0] border-l-4 border-l-[#e6396b] p-6 md:p-7 rounded-md mt-8 shadow-sm">
              <Quote size={26} className="text-[#e6396b] mb-3" />
              <p className="font-serif italic text-[18px] md:text-[20px] text-[#1a1a1a] leading-[1.5] mb-3">
                "I've seen several Fleetwood Mac tribute bands but you are the
                guys who really rock both the look and sound."
              </p>
              <p className="text-[#e6396b] text-[13px] font-semibold tracking-[0.15em]">
                — LENNY CASTRO, PERCUSSIONIST FOR STEVIE NICKS &amp; TOTO
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default About;
